// Module
var code = "<md-chip md-colors=\"$ctrl.colors[$ctrl.status]\" class=\"is-bold is-uppercase\"> <md-icon class=\"is-gutter-right\" ng-if=\"$ctrl.icon\" ng-class=\"{ [$ctrl.icon]: true, 'tmr-icon-24': $ctrl.iconSize == 24 }\" md-colors=\"$ctrl.colors[$ctrl.status]\"></md-icon> <span>{{$ctrl.label}}</span> </md-chip> ";
// Exports
var _module_exports =code;;
var path = 'components/chip/chip.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;